

import Header from "../components/Header";
import Memes from "../components/Memes";

const Home = () => {

    return (
        <div>
            <Header />
            <Memes />
        </div>
    )
}

export default Home;